import {
  MobileFriendly,
  Home,
  AccessTime,
  InsertChart,
  Store,
} from '@material-ui/icons';

/*
 * Slug should be unique
 * If item has children, it doesn't need a path
 */

const menuItems = [
  {
    path: '/dashboard',
    icon: Home,
    title: 'Início',
  },
  {
    path: '/servicos',
    icon: MobileFriendly,
    title: 'Serviços',
  },
  {
    path: '/horarios',
    icon: AccessTime,
    title: 'Horários',
  },
  {
    path: '/negocio',
    icon: Store,
    title: 'Negocio',
  },
  // {
  //   path: '/graficos',
  //   icon: InsertChart,
  //   title: 'Gráficos',
  // },
];

export { menuItems };
